module.exports = __webpack_public_path__ + "static/media/L.3d00b158.jpg";